import { toODataString } from "@progress/kendo-data-query";
import axios from "axios";

class TimesheetDataService {

    getManageExpense = (finalQueryString) => {
        return axios.get(`api/ts/week/expense/manage?${`$count=true&`}${finalQueryString}`);
    };

}

export default new TimesheetDataService();